import { Params } from '@angular/router';
import { createAction } from '@ngrx/store';

import { OrderListQuery } from 'ish-core/models/order-list-query/order-list-query.model';
import { Order } from 'ish-core/models/order/order.model';
import { PagingInfo } from 'ish-core/models/paging-info/paging-info.model';
import { httpError, payload } from 'ish-core/utils/ngrx-creators';

export const createOrder = createAction('[Orders Internal] Create Order');

export const createOrderFail = createAction('[Orders API] Create Order Fail', httpError());

export const createOrderSuccess = createAction(
  '[Orders API] Create Order Success',
  payload<{ order: Order; basketId: string }>()
);

export const loadOrders = createAction('[Orders] Load Orders', payload<{ query: OrderListQuery }>());

export const loadMoreOrders = createAction('[Orders] Load More Orders', payload<{ offset: number; limit: number }>());

export const loadOrdersFail = createAction('[Orders API] Load Orders Fail', httpError());

export const loadOrdersSuccess = createAction(
  '[Orders API] Load Orders Success',
  payload<{ orders: Order[]; query: OrderListQuery; paging: PagingInfo }>()
);

export const loadOrder = createAction('[Orders Internal] Load Order', payload<{ orderId: string }>());

export const loadOrderByAPIToken = createAction(
  '[Orders Internal] Load Order using given API Token',
  payload<{ apiToken: string; orderId: string }>()
);

export const loadOrderFail = createAction('[Orders API] Load Order Fail', httpError());

export const loadOrderSuccess = createAction('[Orders API] Load Order Success', payload<{ order: Order }>());

export const selectOrder = createAction('[Orders Internal] Select Order', payload<{ orderId: string }>());

export const selectOrderAfterRedirect = createAction(
  '[Orders Internal] Select Order After Checkout Redirect',
  payload<{ params: Params }>()
);

export const selectOrderAfterRedirectFail = createAction(
  '[Orders API] Select Order Fail After Checkout Redirect',
  httpError()
);

export const resetOrderErrors = createAction('[Order Internal] Reset Order Errors');

/* DIAS CUSTOMIZATION START */
export const loadCustomOrdersSuccess = createAction(
  '[Orders API] Load Custom Orders Success',
  payload<{ orders: Order[]; query: OrderListQuery; allRetrieved?: boolean }>()
);

export const loadCustomOrders = createAction(
  '[Orders Internal] Load Orders From custom Order API',
  payload<{
    query?: OrderListQuery;
  }>()
);
export const loadMoreCustomOrders = createAction('[Orders Internal] Load More Orders From custom Order API');
export const resetOrders = createAction('[Order Internal] Reset Orders');
export const createMultipleShippingOrder = createAction('[Multiple Shipping Orders] Create Order');

export const createMultipleShippingOrderSuccess = createAction(
  '[Multiple Shipping Orders API] Create Order Success',
  payload<{ order: Order; basketId: string }>()
);

/* DIAS CUSTOMIZATION END */
export const startPaypalOrderCreation = createAction('[Orders] Start Paypal Order Creation');

export const processPaypalOrderCreation = createAction(
  '[Orders] Process Paypal Order Creation',
  payload<{ orderId?: string }>()
);

export const cancelPaypalOrderCreation = createAction('[Orders Internal] Cancel Paypal Order Creation');
